import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_tribe-studio-deploy/artifacts/k4u93ty2_oVSV1jJl.png";
